import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function Blog() {
  return <div className="min-h-screen bg-black text-white selection:bg-yellow-400 selection:text-black" data-id="element-131">
      <Navigation data-id="element-132" />

      <main className="pt-32 pb-24 px-6" data-id="element-133">
        <div className="max-w-7xl mx-auto" data-id="element-134">
          {/* Header */}
          <div className="mb-16" data-id="element-135">
            <h1 className="text-6xl md:text-8xl font-black tracking-tighter mb-8" data-id="element-136">
              THE <span className="text-yellow-400" data-id="element-137">BLOG</span>
            </h1>
            <p className="text-xl text-gray-400 max-w-2xl leading-relaxed" data-id="element-138">
              Insights, thoughts, and stories from our team. We write about
              design, technology, and the creative process.
            </p>
          </div>

          {/* Empty State */}
          <div className="py-24 text-center" data-id="element-139">
            <p className="text-gray-500 text-lg uppercase tracking-widest font-bold" data-id="element-140">
              Coming Soon
            </p>
            <p className="text-gray-600 mt-4" data-id="element-141">
              We're working on something exciting. Stay tuned!
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-142" />
    </div>;
}